export default __webpack_public_path__ + "static/media/redlightLogoDark.c48f2daf.png";